var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.4 25.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\uC790\uC0B0 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.3,3.6v20H2V3.6H18.3m2.1-2H0v24H20.4V1.6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.1,
    width: 2,
    height: 4.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.4,
    width: 2,
    height: 4.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.8,
    width: 2,
    height: 4.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 14.2,
    width: 2,
    height: 4.48
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "9.2 18.4 4.9 13.7 6.4 12.4 9.2 15.4 14.4 9.6 15.9 10.9 9.2 18.4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.739d4ab5e54a62fdd328045686248db8.svg";
export { ForwardRef as ReactComponent };